import { companyDetails } from "@lib/data"
import * as m from "@paraglide/messages"
import "./styles.css"
import { useRouteShellContext } from "@components/routeShellContext"

export function CompanyDetailsTable() {
  const { locale } = useRouteShellContext()
  return (
    <div className="table-wrapper cut-corners">
      <table className="company-details">
        <caption>{m.company_companyDetails_label({}, { locale: locale })}</caption>
        <tbody>
          {companyDetails(locale).map((value) => (
            <tr key={value.label}>
              <th>{value.label}</th>
              <td>
                <ul>
                  {locale === "ja" && ["住所", "会社名"].includes(value.label) ? (
                    <li>{value.content.map((contentKey) => contentKey)}</li>
                  ) : (
                    value.content.map((contentKey) => <li key={contentKey}>{contentKey}</li>)
                  )}
                </ul>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default CompanyDetailsTable
